/**
 * Constants representing the different validation errors.
 */
import _t from 'i18n!nls/author-course';

const exported = {
  PROCTOR_MAX_ATTEMPTS_INVALID: {
    id: 'ProctorMaxAttemptsInvalid',
    get message() {
      return _t('Must be a number from 1 to 99');
    },
  },
};

export default exported;

export const { PROCTOR_MAX_ATTEMPTS_INVALID } = exported;
